import { Controller } from 'stimulus';

// One discussion card on a job's Discussions tab (discussions/_thread).
// Clamps a long opening message behind "Show more", reveals earlier replies
// in place, and opens the reply editor only when someone clicks "Reply…", so
// a tab with many discussions doesn't start a Froala editor for each.
export default class extends Controller {
  static targets = ['body', 'bodyToggle', 'earlier', 'earlierToggle', 'prompt', 'form', 'editor'];

  connect() {
    if (this.hasBodyTarget && this.hasBodyToggleTarget) {
      const body = this.bodyTarget;
      this.bodyToggleTarget.hidden = body.scrollHeight <= body.clientHeight + 2;
    }
  }

  toggleBody(event) {
    event.preventDefault();
    const clamped = this.bodyTarget.classList.toggle('is-clamped');
    this.bodyToggleTarget.textContent = clamped ? 'Show more' : 'Show less';
  }

  toggleEarlier(event) {
    event.preventDefault();
    const button = this.earlierToggleTarget;
    const show = this.earlierTargets.some(reply => reply.hidden);
    this.earlierTargets.forEach((reply) => { reply.hidden = !show; });
    button.textContent = show ? button.dataset.hideLabel : button.dataset.showLabel;
  }

  openReply(event) {
    event.preventDefault();
    this.promptTarget.hidden = true;
    this.formTarget.hidden = false;
    // Adding the controller attribute connects the Froala controller now.
    if (!this.editorTarget.hasAttribute('data-controller')) {
      this.editorTarget.setAttribute('data-controller', 'froala');
    }
  }

  closeReply(event) {
    event.preventDefault();
    this.formTarget.hidden = true;
    this.promptTarget.hidden = false;
  }
}
